import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7.025 14.602c-.067-.109.009-.251.133-.251h3.727a.16.16 0 0 0 .158-.163V3.163c0-.09.07-.163.158-.163h9.6a.16.16 0 0 1 .159.163v11.025c0 .09.07.163.158.163h3.724c.124 0 .2.142.133.251l-8.842 14.322c-.062.101-.204.101-.266 0L7.025 14.602Z"
	})
});
export default SvgDownArrow;
